import {Logic} from '@fantasmagames/slot/src/logic/Logic';

export class WinUtils {
	public static BIG_WIN_THRESHOLD: number = 15;
	public static SUPER_WIN_THRESHOLD: number = 40;
	public static MEGA_WIN_THRESHOLD: number = 70;
	public static EPIC_WIN_THRESHOLD: number = 100;

	public static NICE_WIN_THRESHOLD_LOW: number = 4;
	public static NICE_WIN_THRESHOLD_HIGH: number = 8;

	public static NICE_WIN_ONE_ROUND_THRESHOLD_LOW: number = 2;
	public static NICE_WIN_ONE_ROUND_THRESHOLD_HIGH: number = 5;

	public static isBigWin(logic: Logic): boolean {
		return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.BIG_WIN_THRESHOLD;
	}

	public static isNiceWin(logic: Logic): boolean {
		// Not used in medallion.
		return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.NICE_WIN_THRESHOLD_LOW && logic.getSpinWin() < logic.getTotalBet() * WinUtils.NICE_WIN_THRESHOLD_HIGH;
	}

	public static isBigWinNextRound(logic: Logic): boolean {
		return logic.getNextSpinWin() >= logic.getTotalBet() * WinUtils.BIG_WIN_THRESHOLD;
	}

	public static isTotalWinBigWin(logic: Logic): boolean {
		return logic.getWin() >= logic.getTotalBet() * WinUtils.BIG_WIN_THRESHOLD;
	}

	public static isSpinNiceWin(logic: Logic): boolean {
		// Not used in medallion.
		return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_LOW && logic.getSpinWin() < logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_HIGH;
	}

	public static isSpinExcellentWin(logic: Logic): boolean {
		return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_HIGH;
	}

	public static isSpinAboveNormalWin(logic: Logic): boolean {
		return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_LOW;
	}

	public static isRoundAboveNormalWin(logic: Logic): boolean {
		return logic.getWin() >= logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_LOW;
	}

	public static isRoundNiceWin(logic: Logic): boolean {
		return logic.getWin() >= logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_LOW && logic.getWin() < logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_HIGH;
	}

	public static isRoundExcellentWin(logic: Logic): boolean {
		return logic.getWin() >= logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_HIGH;
	}

	public static inBigWinBigWin(logic: Logic): boolean {
		return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.BIG_WIN_THRESHOLD && logic.getSpinWin() < logic.getTotalBet() * WinUtils.SUPER_WIN_THRESHOLD;
	}

	public static inBigWinSuperWin(logic: Logic): boolean {
		return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.SUPER_WIN_THRESHOLD && logic.getSpinWin() < logic.getTotalBet() * WinUtils.MEGA_WIN_THRESHOLD;
	}

	public static inBigWinMegaWin(logic: Logic): boolean {
		return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.MEGA_WIN_THRESHOLD && logic.getSpinWin() < logic.getTotalBet() * WinUtils.EPIC_WIN_THRESHOLD;
	}

	public static inBigWinEpicWin(logic: Logic): boolean {
		return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.EPIC_WIN_THRESHOLD;
	}

	public static inBigWinBigWinNextSpin(logic: Logic): boolean {
		return logic.getNextSpinWin() >= logic.getTotalBet() * WinUtils.BIG_WIN_THRESHOLD && logic.getNextSpinWin() < logic.getTotalBet() * WinUtils.SUPER_WIN_THRESHOLD;
	}

	public static inBigWinSuperWinNextSpin(logic: Logic): boolean {
		return logic.getNextSpinWin() >= logic.getTotalBet() * WinUtils.SUPER_WIN_THRESHOLD && logic.getNextSpinWin() < logic.getTotalBet() * WinUtils.MEGA_WIN_THRESHOLD;
	}

	public static inBigWinMegaWinNextSpin(logic: Logic): boolean {
		return logic.getNextSpinWin() >= logic.getTotalBet() * WinUtils.MEGA_WIN_THRESHOLD && logic.getNextSpinWin() < logic.getTotalBet() * WinUtils.EPIC_WIN_THRESHOLD;
	}

	public static inBigWinEpicWinNextSpin(logic: Logic): boolean {
		return logic.getNextSpinWin() >= logic.getTotalBet() * WinUtils.EPIC_WIN_THRESHOLD;
	}

	public static isWin(logic: Logic): boolean {
		return logic.getWin() > 0;
	}

	public static isSpinWin(logic: Logic): boolean {
		return logic.getSpinWin() > 0;
	}

	public static isWinNumberExcellent(winNumber: number, bet: number): boolean {
		return winNumber >= bet * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_HIGH;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/logic/WinUtils.ts